import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Badge } from "../ui/badge";
import { Button } from "../ui/button";
import { Clock, ChevronUp, ChevronDown, Loader2, Trash2 } from "lucide-react";

function formatCurrency(v) { return new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR" }).format(v); }

export function ForecastHistory({
  savedForecasts, historyOpen, loading, periodLabel,
  onToggle, onLoad, onDelete,
}) {
  return (
    <Card className="border-none shadow-soft">
      <button className="w-full" onClick={onToggle} data-testid="history-toggle-btn">
        <CardHeader className="pb-2">
          <CardTitle className="font-heading text-base flex items-center justify-between">
            <span className="flex items-center gap-2">
              <Clock className="w-4 h-4 text-primary" />
              Historial de previsiones
              {savedForecasts.length > 0 && (
                <Badge variant="secondary" className="text-xs">{savedForecasts.length}</Badge>
              )}
            </span>
            {historyOpen
              ? <ChevronUp className="w-4 h-4 text-muted-foreground" />
              : <ChevronDown className="w-4 h-4 text-muted-foreground" />
            }
          </CardTitle>
        </CardHeader>
      </button>

      {historyOpen && (
        <CardContent className="p-0">
          {loading ? (
            <div className="py-6 flex justify-center">
              <Loader2 className="w-5 h-5 animate-spin text-muted-foreground" />
            </div>
          ) : savedForecasts.length === 0 ? (
            <div className="py-6 text-center text-sm text-muted-foreground">
              Sin previsiones guardadas aun
            </div>
          ) : (
            <div className="divide-y max-h-72 overflow-y-auto">
              {savedForecasts.map(fc => (
                <button
                  key={fc.forecast_id}
                  onClick={() => onLoad(fc)}
                  className="w-full px-4 py-3 text-left hover:bg-muted/50 transition-colors group flex items-start justify-between gap-2"
                  data-testid={`history-item-${fc.forecast_id}`}
                >
                  <div className="min-w-0">
                    <div className="text-sm font-medium truncate">{fc.name}</div>
                    <div className="text-xs text-muted-foreground flex items-center gap-2 mt-0.5 flex-wrap">
                      <Badge variant="secondary" className="text-xs py-0 px-1.5">{periodLabel(fc.period)}</Badge>
                      <span>{fc.ingredients_count} ingredientes</span>
                      <span className="text-primary font-mono">{formatCurrency(fc.total_estimated_cost)}</span>
                    </div>
                  </div>
                  <button
                    className="opacity-0 group-hover:opacity-100 text-muted-foreground hover:text-destructive transition-all shrink-0 mt-0.5"
                    onClick={(e) => onDelete(fc.forecast_id, e)}
                  >
                    <Trash2 className="w-3.5 h-3.5" />
                  </button>
                </button>
              ))}
            </div>
          )}
        </CardContent>
      )}
    </Card>
  );
}
